import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import IconCity from "../../../assets/images/icon-city.png";
import LoginOtp from "./loginOtp";
import SignUpOtp from "./signupOtp";
import FacebookIcon from "@mui/icons-material/Facebook";
// import { GoogleOutlined } from "@ant-design/icons";
import google_icon from "../../../assets/images/google_logo.png";

const SignUpModal = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <div className="login-section">
      <Link to="" onClick={showModal}>
        {props.signup}
      </Link>
      <Modal
        // className="login-modal-section "
        // title={props.title}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered=" true"
        footer={null}
        title={null}
        header={null}
      >
        <Container className="main-signup-section">
          <Row className="pt-1">
            <Col className="d-flex">
              <img src={IconCity} alt="city-icon" />
              {/* <LocationCityIcon  /> */}
              <p className="m-0 p-0  px-3 signup-title ">Sign Up</p>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Button className="register-btn-wrap">
                {/* <GoogleOutlined  /> */}
                <img className="google-logo" src={google_icon} alt="google-icon"/>
                Google
              </Button>
            </Col>
            <Col md={6}>
              <Button className="register-btn-wrap-color">
                <FacebookIcon className="fb fb-btn" />
                Facebook
              </Button>
            </Col>
          </Row>

          <div className="signup-or-wrap">
            <div className="signup-or-hr"></div>
            <div className="signup-or">Or</div>
            <div className="signup-or-hr"></div>
          </div>

          <Row className="mb-1 ">
            <Col>
              <Input
                placeholder="Enter Mobile number / Email address"
                className=" p-3 px-3 mt-3  mobile-input "
              />
            </Col>
          </Row>

          <Row className="mb-1 ">
            <Col>
              <div className="signup-input-wrap"></div>
            </Col>
          </Row>

          <Row className="m-3 ">
            <Col>
              <div className="d-flex flex-column justify-content-center align-items-center ">
                {/* <Button type="primary" className="proceed-btn mt-2 ">
                  Procced
                </Button> */}
                <Button type="primary" className="proceed-btn">
                  {/* <LoginOtp /> */}
                  <SignUpOtp />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
    </div>
  );
};

export default SignUpModal;
